import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-popmodel',
  templateUrl: './popmodel.component.html',
  styleUrls: ['./popmodel.component.css']
})
export class PopmodelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
